/**
 * Initialize dropdown with dynamic positioning
 * @param {string} triggerSelector - CSS selector for trigger button
 * @param {string} targetSelector - CSS selector for dropdown panel
 */
export function initDropdown(triggerSelector, targetSelector) {
	const trigger = document.querySelector(triggerSelector);
	const target = document.querySelector(targetSelector);

	if (!trigger || !target) return;

	const DESKTOP_WIDTH = 420;
	const GAP = 12;
	const EDGE_PADDING = 8;
	const MOBILE_BREAKPOINT = 768;

	function positionDropdown() {
		const rect = trigger.getBoundingClientRect();
		const top = rect.bottom + GAP;

		if (window.innerWidth < MOBILE_BREAKPOINT) {
			Object.assign(target.style, {
				left: EDGE_PADDING + 'px',
				right: EDGE_PADDING + 'px',
				top: top + 'px',
				width: 'auto',
			});
		} else {
			const left = Math.max(EDGE_PADDING, rect.right - DESKTOP_WIDTH);
			Object.assign(target.style, {
				left: left + 'px',
				right: 'auto',
				top: top + 'px',
				width: DESKTOP_WIDTH + 'px',
			});
		}
	}

	trigger.addEventListener('click', (e) => {
		e.stopPropagation();
		const isHidden = target.classList.contains('hidden');
		if (isHidden) positionDropdown();
		target.classList.toggle('hidden');
	});

	window.addEventListener('resize', () => {
		if (!target.classList.contains('hidden')) positionDropdown();
	});

	let scrollStart = 0;
	window.addEventListener('scroll', () => {
		if (target.classList.contains('hidden')) {
			scrollStart = window.scrollY;
			return;
		}
		if (Math.abs(window.scrollY - scrollStart) > 30) {
			target.classList.add('hidden');
		}
	}, true);

	document.addEventListener('click', (e) => {
		if (!trigger.contains(e.target) && !target.contains(e.target)) {
			target.classList.add('hidden');
		}
	});
}
